import { Breadcrumbs } from 'components/city-blocks/breadcrumbs';
import { ZipCodeInput } from 'components/hero-block/zip-code-input';
import Head from 'next/head';
import React from 'react';
import { NoFollowLink } from 'shared/no-follow-link';
import { getAssetPath } from 'utils/asset-utils';
import { Crumb } from 'utils/breadcrumb-util';
import { getFrontEndUrl } from 'utils/environment-util';

const DEFAULT_IMAGE_SRC = getAssetPath('/images/CDN/food_bg.png');

interface IProps {
  className?: string;
  heroText: React.ReactNode;
  crumbs: Crumb[];
  zipCode?: string;
  prefillZipCode?: boolean;
  backgroundImage?: string;
}

export const HeroBlock: React.FC<IProps> = ({
  className,
  heroText,
  crumbs,
  zipCode,
  prefillZipCode,
  backgroundImage,
}) => {
  const imageSrc = backgroundImage || DEFAULT_IMAGE_SRC;

  return (
    <>
      <Head>
        <link rel='preload' media='(min-width: 768px)' href={imageSrc} as='image' />
        {/* <link rel='preload' media='(min-width: 576px) and (max-width: 767px)' href={MEDIUM_IMAGE_SRC} as='image' /> */}
        {/* <link rel='preload' media='(max-width: 576px)' href={SMALL_IMAGE_SRC} as='image' /> */}
      </Head>
      <div
        className={`relative mb-10 flex size-full flex-col items-center justify-center p-4 py-10 md:px-24 md:py-16 ${className} `}>
        <div className='absolute inset-0 z-0 size-full'>
          <picture className='absolute top-0 size-full'>
            <img className='absolute top-0 size-full object-cover object-center' src={imageSrc} alt='Hero image' />
          </picture>
        </div>

        <Breadcrumbs className='z-10 mb-6 rounded-lg backdrop-blur' crumbs={crumbs} />
        <h1
          className='z-10 mb-6 text-[40px] font-bold leading-[48px] text-white drop-shadow-sm md:text-[64px] md:leading-[68px]'
          data-testid='hero-block-header'>
          {heroText}
        </h1>

        <ZipCodeInput className='z-10 mb-5' defaultZipCode={zipCode} prefillZipCode={prefillZipCode} />

        <span className='z-10 flex flex-row gap-2 text-base text-white'>
          <span className='font-medium'>Already have an account?</span>
          <NoFollowLink href={`${getFrontEndUrl()}/login`} className='font-bold underline'>
            Log in
          </NoFollowLink>
        </span>
      </div>
    </>
  );
};
